export default class MassiaDateController {
	static $inject = [
		'$scope',
		'$state',
		'$stateParams',
		'MassiaSelectService',
		'notification',
		'$location',
		'$translate',
		'SharedDataService',
		'$attrs',
		'$timeout',
		'MassiaSelectSupervisorService',
		'_'
	];

	constructor(
		$scope,
		$state,
		$stateParams,
		MassiaDateService,
		notification,
		$location,
		$translate,
		SharedDataService,
		$attrs,
		$timeout,
		MassiaSelectSupervisorService,
		_
	) {
		this.$scope = $scope;
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.MassiaDateService = MassiaDateService;
		this.notification = notification;
		this.$location = $location;
		this.$translate = $translate;
		this.SharedDataService = SharedDataService;
		this.$attrs = $attrs;
		this.MassiaSelectSupervisorService = MassiaSelectSupervisorService;
		this.$timeout = $timeout;
		this._ = _;

		this.searchText = '';
		this.name = this.$attrs.name;
		this.filteredOptions = [];
		this.messageError = '';
		this.error = false;
	}

	async $onInit() {
		// Créer la promise pour le supervisor
		this.readyPromise = new Promise((resolve) => (this._resolveReady = resolve));
		//Abonnement au Supervisor
		this.MassiaSelectSupervisorService.addController(this);

		this.isEditMode = false;

		if (this.ngModel === 'now') {
			this.ngModel = this.formatDate(new Date());
		}

		var dataObject = {
			value: this.ngModel,
			messageType: '',
			message: ''
		};

		this.SharedDataService.setData(this.name, dataObject);

		// Observe ngModel
		this.$scope.$watch(
			() => this.ngModel,
			(newValue, oldValue) => {
				if (newValue === oldValue) return;

				// Annule le précédent debounce
				if (this.debouncePromise) {
					this.$timeout.cancel(this.debouncePromise);
				}

				// Lance un nouveau debounce de 500 ms
				this.debouncePromise = this.$timeout(() => {
					const corrected = this.fixInvalidDate(newValue);

					// Corrige le modèle si besoin
					if (corrected !== newValue) {
						this.ngModel = corrected;
					}

					// Propage la valeur finale
					this.SharedDataService.setData(this.name, {
						value: this.ngModel,
						messageType: '',
						message: ''
					});
					if (this.ngChange) {
						this.ngChange();
					}
				}, 500); // ← délai 500 ms
			}
		);

		//On prévient le superviseur qu'on est prêt
		this.initComplete = true;
		this._resolveReady();
	}

	// Vérifie et remplace les dates impossibles
	fixInvalidDate(value) {
		// Ignore les formats invalides
		const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(value);
		if (!match) return value;

		let [_, d, m, y] = match;
		console.log('🔥 - MassiaDateController - fixInvalidDate - _:', _);

		d = parseInt(d, 10);
		m = parseInt(m, 10);
		y = parseInt(y, 10);

		// Crée une date avec débordement
		const real = new Date(y, m - 1, d);

		// Vérifie si la date existe réellement
		if (real.getDate() === d && real.getMonth() + 1 === m) {
			return value;
		}

		// Détermine le dernier jour du mois
		const lastDay = new Date(y, m, 0).getDate();

		// Renvoie la date corrigée
		return `${('0' + lastDay).slice(-2)}/${('0' + m).slice(-2)}/${y}`;
	}

	async verifyForm(newValueObject) {
		this.error = false;
		if (newValueObject.messageType === 'error') {
			this.error = true;
			this.messageError = newValueObject.message;
		}
	}

	formatDate(date) {
		const pad = (n) => (n < 10 ? '0' + n : n);
		const day = pad(date.getDate());
		const month = pad(date.getMonth() + 1);
		const year = date.getFullYear();
		return `${day}/${month}/${year}`;
	}

	$onDestroy() {
		this.MassiaSelectSupervisorService.removeController(this);
	}

	reset() {
		this.ngModel = 0;
		this.searchText = '';
		this.options = [];
	}

	onFocus() {
		this.isFocused = true;
	}
}
